import type { paths } from '@pba/types-openapi-node';
import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type AddEventDistributionListBodyRequestParams =
  paths['/events/{eventId}/distribution-list']['post']['requestBody']['content']['application/json'];
type AddEventDistributionListPathRequestParams =
  paths['/events/{eventId}/distribution-list']['post']['parameters']['path'];

export const addEventDistributionList = async ({
  body,
  routeParams: { eventId },
}: BodyRouteParamsRequest<AddEventDistributionListBodyRequestParams, AddEventDistributionListPathRequestParams>) =>
  nodeApiClient.post<undefined, ApiClientResponse<undefined>>(
    nodeApiRoutes.events.distributionList.create(eventId),
    body,
  );
